import { AiFieldFilter, FieldFilter } from '../filter';

export function isAiFieldFilterCriteria(
  criteria: FieldFilter | AiFieldFilter,
): criteria is AiFieldFilter {
  return criteria && 'isAiGenerated' in criteria;
}

export function isFieldFilterCriteria(
  criteria: FieldFilter | AiFieldFilter,
): criteria is FieldFilter {
  return criteria && 'field' in criteria;
}

const isAiFieldFilterValid = (filter: AiFieldFilter) => {
  return filter.value !== '';
};

export function isFieldFilterValid(
  criteria: FieldFilter | AiFieldFilter,
): boolean {
  return isFieldFilterCriteria(criteria)
    ? FieldFilter.isValid(criteria)
    : isAiFieldFilterValid(criteria);
}
